import React, { useEffect, useState } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useAppContext } from "store/context";
import DisplayOptions from "./components/DisplayOptions";
import SkeletonContent from "./components/SkeletonContent";
import Header from "../Header";

const DisplayOptionsContainer = ({ merchant_id, devices }) => {
  const { firebase } = useAppContext();
  const [data, loading] = useDocumentData(firebase.firestore().collection("display_options").doc(merchant_id));
  const reconcileCategories = firebase.functions().httpsCallable("reconcileCategories");
  const [reconciled, setReconciled] = useState();

  useEffect(() => {
    const reconcile = async () => {
      const { data: success } = await reconcileCategories();
      setReconciled(success);
    };
    reconcile();
    // eslint-disable-next-line
  }, []);

  const onUpdate = async (doc) => {
    await firebase.firestore().collection("display_options").doc(merchant_id).set(doc, { merge: true });
  };

  return (
    <>
      <Header title="Menu Category Assignment" />
      {loading || !data || !reconciled ? (
        <SkeletonContent />
      ) : (
        <DisplayOptions displayOptions={data} devices={devices} handleUpdate={onUpdate} />
      )}
    </>
  );
};

export default DisplayOptionsContainer;
